"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_dom_1 = require("react-dom");
const _1 = require("./");
const viewer_1 = require("../../components/viewer/viewer");
const user_1 = require("../../reducers/user");
const intl_1 = require("../../reducers/intl");
const preloadedState = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;
viewer_1.viewerStore.injectAll({ user: user_1.user, intl: intl_1.intl });
react_dom_1.render(_1.SceneJSX(viewer_1.viewerStore), document.getElementById('root'));
